export const keys = {
  all: ['projects'] as const,
  details: () => [...keys.all, 'detail'] as const,
  detail: (id: number) => [...keys.details(), id] as const,
  templatePreview: (id: number) => ['preview', id] as const,
  taskStatus: (uuid: string | undefined) => ['taskStatus', uuid] as const,
  PROJECT_ASYNC_UPDATE_STATUS: 'PROJECT_ASYNC_UPDATE_STATUS',
  PROJECT_ASYNC_POPULATE_STATUS: 'PROJECT_ASYNC_POPULATE_STATUS',
};
